import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataService } from '@app/core/services/data.service';
import { dictionaryItems } from '@app/core/constants/dictionaryItems';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';
import { BuildingInformationHistoryService } from '../services/building-information-history.service';
import { Adb2cService } from '@app/blocks/adb2c/services/adb2c/adb2c.service';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
    selector: 'app-building-information-history',
    imports: [ CommonModule, SpinnerComponent ],
    templateUrl: './building-information-history.component.html',
    styleUrl: './building-information-history.component.scss',
})
export class BuildingInformationHistoryComponent implements OnInit, OnDestroy {
    constructor(private dataService: DataService,
        private adb2cService: Adb2cService,
        private buildingInformationHistoryService: BuildingInformationHistoryService) { }

    loaded: boolean = false;
    showNoRequestsFound: boolean = false;
    config: any = {
        defaultMaxRequests: 30,
    }
    buildingInformationHistory: any

    private destroy$ = new Subject<void>();
    private userSubscription?: Subscription;

    ngOnInit(): void {

        this.dataService.getDictionaryItems().subscribe({
            next: (response) => {
                this.config.dictionary = response.data;
                this.config.showPaymentsFromText = this.dataService.getDictionaryItemByKeyAndLanguage(this.config.dictionary, dictionaryItems.showPaymentsFrom, "en-GB");
                this.config.customText = this.dataService.getDictionaryItemByKeyAndLanguage(this.config.dictionary, dictionaryItems.custom, "en-GB");
                this.config.daysText = this.dataService.getDictionaryItemByKeyAndLanguage(this.config.dictionary, dictionaryItems.days, "en-GB");
                this.config.toText = this.dataService.getDictionaryItemByKeyAndLanguage(this.config.dictionary, dictionaryItems.to, "en-GB");
                this.config.fromText = this.dataService.getDictionaryItemByKeyAndLanguage(this.config.dictionary, dictionaryItems.from, "en-GB");
                this.config.filterText = this.dataService.getDictionaryItemByKeyAndLanguage(this.config.dictionary, dictionaryItems.filter, "en-GB");

            },
            error: (error) => {
                console.log(error);
            }
        });

        this.adb2cService.getUser();
        this.userSubscription = this.adb2cService.activeUser.asObservable().pipe(takeUntil(this.destroy$)).subscribe(user => {
            if (user && user.sub && user[ 'tenancy_reference' ]) {
                this.buildingInformationHistoryService.getBuildingInformationHistory(user.sub, user[ 'tenancy_reference' ]!).subscribe({
                    next: (response) => {
                        this.loaded = false;
                        //console.log(response);
                        if (response && response.informationRequests && (response.informationRequests.length > 0)) {
                            this.buildingInformationHistory = response.informationRequests.slice(0, this.config.defaultMaxRequests);
                            /*vm.customerSafetyHistory = response.data.safetyConcerns;*/
                            //console.log(this.buildingInformationHistory);
                            this.showNoRequestsFound = false;
                        } else {
                            this.showNoRequestsFound = true;
                        }
                        this.loaded = true;
                    },
                    error: (error) => {
                        console.error(error);
                        this.loaded = true;
                    }
                });
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();

        this.userSubscription?.unsubscribe();
    }
}
